/* eslint-disable max-len */
export const translations = {
  DELIVERY_IMPORT: 'Téléverser les info de livraison',
  LOADING_IMPORT: 'Téléverser les info de chargement',
  FREIGHT_IMPORT: 'Téléverser les données de fret',
  MASTER_IMPORT: 'Téléverser les données principales',
  START_IMPORT: "Démarrer l'importation",
  APP_TITLE: 'Téléverseur de données | Jules AI',
  LOGISTIC_FORWARDER: 'Sélectionner un transitaire logistique',
  LOGISTIC_FORWARDER_NAME: 'Transitaire',
  SHIPPING_LINE_NAME: 'Ligne de transport maritime',
  LOADING_UNIT: 'Unité de volume et type de chargement',
  DELIVERY_UNIT: 'Unité de volume et type de livraison',
  GO: 'Démarrer',
  GO_BACK: 'Revenir en arrière',
  IMPORT_DATA: 'Importer des données',
  IMPORT_DELIVERIES: 'Importer des livraisons',
  IMPORT_LOADINGS: 'Importer des chargements',
  CHECKOUT_DELIVERIES_ON_APP: 'Vérifier les livraisons sur l application web',
  CHECKOUT_LOADINGS_ON_APP: 'Vérifier les chargements sur l application web',
  POPUP_VALIDATION: 'Obligatoire',
  POPUP_LOADING_VALIDATION: 'Tous les champs sont obligatoires',
  LOADING_TYPE: 'Sélectionner le type de chargement',
  DELIVERY_TYPE: 'Sélectionner le type de livraison',
  VALIDITY_MONTH: 'Sélectionner le mois de validité',
  LOGISTIC_MATERIAL: 'Sélectionner le matériel logistique',
  QUALITY_GROUP: 'Sélectionner le groupe de qualité',
  INCO_TERMS: "Sélectionner l'incoterm",
  LOGISTIC_FORWARDER_SHIPPING_LINE: 'Sélectionner la valeur',
  FREIGHT_POPUP: 'Sélectionnez les détails ci-dessous',
  INVALID_CREDENTIALS: 'Votre email et/ou votre mot de passe sont incorrects',
  VALID_CREDENTIALS: 'Connexion réussie',
  SAMPLE_TEMPLATE: 'Télécharger le modèle',
  SUPPORT_HELP: 'Soutien',
  CONTRACT_IMPORT: 'Renouveler les détails du contrat',
  CONTRACT: 'Renouveler le contrat',
  CONFIRMATION_TEXT:
    'Êtes-vous sûr de vouloir renouveler les enregistrements ?',
  CONFIRMATION_YES: 'Oui',
  CONFIRMATION_NO: 'Non',
  RENEW: 'Renouveler',
  RENEWING_TEXT: 'Renouvellement des enregistrements',
  FROM: 'de',
  TO: 'à',
  LOADINGS_HEADER: 'Chargements',
  DELIVERIES_HEADER: 'Livraisons',
  FREIGHT_HEADER: 'Coût de fret',
  MASTER_HEADER: 'Données principales',
  CONTRACT_RENEWAL_HEADER: 'Renouvellement de contrat',
  LOGOUT: 'Déconnexion',
  VOLUME_UNIT: 'Sélectionner lunité de volume',
  MATERIAL: 'Matériau',
  ITEM: 'Article',
  LOADING_TEXT: 'Veuillez patienter',
  'The commodity or material name': "Le nom de la marchandise ou de l'article",
  'The material name cannot be blank':
    'Le nom du matériau ne peut pas être vide',
  'Net Weight': 'Poids net',
  'Quantity of material in delivery': 'Quantité de matériel dans la livraison',
  'Quantity cannot be left blank':
    'La quantité ne peut pas être laissée en blanc',
  'Date of delivery': 'Date de livraison',
  'Date of delivery cannot be left blank':
    'La date de livraison ne peut être laissée en blanc',
  'Reference number': 'Numéro de plaque',
  'Container reference number': 'Numéro de référence du conteneur',
  'ERP Container id': 'Numéro de référence du conteneur ERP',
  'Gross Weight': 'Poids brut',
  'Maximum Gross Weight': 'Poids brut maximum',
  'General comment': 'Commentaire général',
  'Loading comment': 'Commentaire sur le chargement',
  'Delivery comment': 'Commentaire de livraison',
  'Tare Weight': 'Poids de la tare',
  'Packages': 'Colis',
  'Quantity in tons': 'Quantité en tonnes',
  'Quantity converted to tons': 'Quantité convertie en tonnes',
  'Quality id': 'Identifiant de la qualité',
  'The id linked to the quality name': "L'Identifiant lié au nom de qualité",
  'Container id': 'Identifiant du conteneur',
  'The truck plate number or container reference number':
    'Le numéro de plaque du camion ou le numéro de référence du conteneur',
  'Jules number': 'Num. Jules',
  'CT number for the truck or container':
    'Numéro de CT du camion ou du conteneur',
  'Other delivery number': 'Autre numéro de livraison',
  'Any other delivery reference number':
    'Tout autre numéro de référence de livraison',
  'Buy operation id': "Identifiant de l'opération d'achat",
  'Sell operation id': "Identifiant de l'opération de vente",
  'Container operation quality id':
    "Identifiant de qualité de l'opération de conteneur",
  'Unit (qty)': 'Unité (qté)',
  'Seal number': 'Numéro de scellé',
  'Container seal number': 'Numéro de scellé du conteneur',
  'Thickness': 'Epaisseur',
  'Unit (thickness)': 'Unité (épaisseur)',
  'Length': 'Longueur',
  'Unit (length)': 'Unité (longueur)',
  'Width': 'Largeur',
  'Unit (width)': 'Unité (largeur)',
  'Height': 'Hauteur',
  'Unit (height)': 'Unité (hauteur)',
  'Unit (dimensions)': 'Unité (dimensions)',
  'User delivery type': "Type de livraison à l'utilisateur",
  'Package Reference': 'Paquet Référence',
  'Delivery tare weight quantity': 'Quantité de poids de tare à la livraison',
  'Delivery tare weight cannot be left blank':
    'Le poids de la tare de livraison ne peut pas être laissé vide',
  'Delivery tare weight volume': 'Volume du poids de la tare de livraison',
  'Delivery tare volume cannot be left blank':
    'Le volume de la tare de livraison ne peut pas être laissé vide',
  'Height cannot be left blank': 'La hauteur ne peut pas être laissée en blanc',
  'Height unit cannot be left blank':
    'L unité de hauteur ne peut pas être laissée vide',
  'Dimension unit cannot be left blank':
    'L unité de dimension ne peut être laissée vide',
  'Thickness cannot be left blank': 'L épaisseur ne peut pas être laissée vide',
  'Thickness unit cannot be left blank':
    'L unité d épaisseur ne peut pas être laissée vide',
  'If you press the \"Go back\" button, you will lose the progress of the current step.':
    // eslint-disable-next-line max-len
    'Si vous appuyez sur le bouton "Revenir en arrière", vous perdrez la totalité de la progression de toutes les étapes.',
  'If you press the \"Go back\" button, you will lose the entire progress of all steps.':
    'Si vous appuyez sur le bouton "Revenir en arrière", vous perdrez toute la progression de toutes les étapes.',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error wont be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Êtes-vous sûr de vouloir soumettre vos données ? Les lignes comportant une erreur ne seront pas importées. Si oui, utilisez le bouton "Soumettre". Dans le cas contraire, cliquez sur le bouton "Précédent"',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Etes-vous sûr de vouloir soumettre vos données ? Si oui, cliquez sur le bouton "Soumettre". Sinon, appuyez sur le bouton "Précédent".',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Etes-vous sûr de vouloir soumettre vos données ? Les lignes comportant une erreur seront également importées. Si oui, veuillez utiliser le bouton "Soumettre". Sinon, cliquez sur le bouton "Précédent".',
  // eslint-disable-next-line max-len
  'Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button.':
    // eslint-disable-next-line max-len
    'Votre importation a donné lieu à des erreurs {{error}}. Si vous souhaitez corriger ces erreurs dans l application, cliquez sur le bouton "Continuer". Sinon, vous pouvez télécharger le tableau fusionné au format Excel (.xlsx) en cliquant sur le bouton "Exporter au format Excel".',
  'Port of loading': 'Port de chargement',
  'Port of loading should not be blank':
    'Le port de chargement ne doit pas être vide',
  'Port of destination': 'Port de destination',
  'Port of destination should not be blank':
    'Le port de destination ne doit pas être vide',
  'Shipping line': "Ligne d'expédition",
  'Shipping line should not be left blank':
    "La ligne d'expédition ne doit pas être laissée en blanc",
  'Material group': "Groupe d'articles",
  'Material group should not be left blank':
    "Le groupe d'articles ne doit pas être laissé vide",
  'Cost': 'Coût',
  'Cost currency': 'Devise du coût',
  'Comment': 'Commentaire',
  'Other cost': 'Autres coûts',
  'Other cost currency': 'Devise des autres coûts',
  'BL cost': 'Coût BL',
  'BL currency': 'Devise du BL',
  'Customs currency': 'Devise douanière',
  'Freight cost': 'Coût du fret',
  'Freight cost should not be left blank':
    'Le coût du fret ne doit pas être laissé vide',
  'Freight cost currency code': 'Code de devise du coût du fret',
  'Logistic forwarder': 'Transporteur logistique',
  'Logistic material': 'Matériel logistique',
  'Incoterm': 'Incoterm',
  'Comment': 'Commentaire',
  'Other cost': 'Autres coûts',
  'Other cost currency': 'Autres coûts devises',
  'Comment on freight': 'Commentaire sur le fret',
  'Last validity date': 'Dernière date de validité',
  'First validity date': 'Première date de validité',
  'Cost volume': 'Volume des coûts',
  'Cost volume should not be left blank':
    'Le volume des coûts ne doit pas être laissé en blanc',
  'BL cost value': 'Valeur du coût BL',
  'Currency code of BL cost': 'Code devise du coût BL',
  'Miscellaneous cost': 'Coûts divers',
  'Currency code of THC admin cost': 'Code devise du coût administratif THC',
  'Other cost volume': 'Volume des autres coûts',
  'Other cost volume should not be left blank':
    'Le volume des autres coûts ne doit pas être laissé en blanc',
  'Customs cost': 'Coût douanier',
  'Currency code of custom cost': 'Code devise du coût douanier',
  'Select validity month': 'Sélectionner le mois de validité',
  'Select logistic material': 'Sélectionner le matériel logistique',
  'Select quality group': 'Sélectionner le groupe de qualité',
  'Select incoterm': "Sélectionner l'incoterm",
  'Check out freights on web app': "Vérifier les frets sur l'application web",
  'Import Freight': "Fret à l'importation",
  'Date of loading': 'Date de chargement',
  'Date of loading cannot be left blank': 'La date de chargement ne peut être laissée en blanc',
  'Container / Truck number': 'Numéro du conteneur / du camion',
  'MGW': 'MGW',
  'Weight unit': 'Unité du poids',
  'Material ID': "Identifiant de la qualité",
  'User loading type': "Type de chargement de l'utilisateur",
  'ERP container ID': 'ID du conteneur (ERP)',
  'Transport Rate': 'Taux de transport',
  'Upload transport rate details': 'Télécharger les détails du tarif de transport',
  'Select transport mode': 'Sélectionner le mode de transport',
  'Barge': 'Barge',
  'Rail': 'Rail',
  'Road': 'Road',
  'Select transport type': 'Sélectionner le type de transport',
  'Select material group': 'Sélectionner le groupe de matériaux',
  'Check out transport rates on web app': "Consulter les tarifs de transport sur l'application web",
  'Transport cost currency code': 'Code devise du coût du transport',
  'Carrier': 'Transporteur',
  'Loading area': 'Zone de chargement',
  'Destination area': 'Zone de destination',
  'Logistics': 'Logistique',
  'Import transport rate': "Taux de transport à l'importation",
  'Transport mode': 'Mode de transport',
  'cost': 'coût',
  'Volumic customs cost': 'Coût douanier volumique',
  'Volumic customs currency': 'Devise de la douane volumique',
  'Currency code of volumic customs': 'Code monétaire de la douane volumique',
  'Volumic customs volume': 'Volume de la douane volumique',
  "Volumic customs volume shouldn't be left blank": "Le volume de la douane volumique ne doit pas être laissé vide",
  'Demurrage in days': 'Surestaries en jours',
  'Detention in days': 'Retenue en jours',
  'Lane': 'Voie',
  'First validity date cannot be left blank': 'La première date de validité ne peut être laissée en blanc',
  'Last validity date cannot be left blank': 'La dernière date de validité ne peut être laissée en blanc',
  "Transport All In Rate": "Transport Tarifs forfaitaires",
  "Pre-carriage area": "Aire de pré-chariot",
  "Pre carriage volume": "Volume de pré-transport",
  "Pre carriage cost": "Frais de pré-acheminement",
  "Pre carriage currency": "Monnaie de pré acheminement",
  "Packing type": "Type d'emballage",
  "Single container": "Conteneur unique",
  "Multiple container": "Conteneur multiple",
  "UPLOAD_TYPE": "Sélectionner le type de téléchargement",
  CONFIRMATION_TEXT_SAMPLE_DOC: "Si vous avez rencontré un problème lors de l'ouverture d'un fichier dans Excel, veuillez cliquer sur oui.",
  CONFIRMATION_CONTINUE: 'Continuer',
  CONFIRMATION_CANCEL: 'Annuler',
  "Select deviation type": "Sélectionner le type de déviation",
  "Sterile Weight": "Poids stérile",
  "Sterile Gross Weight": "Poids brut stérile",
  "Pieces": "Pièces",
  "Upload container info": "Télécharger les informations sur le conteneur",
  "Delivery info": "Informations sur la livraison",
  "Loading info": "Info chargement",
  "Logistic rates": "Tarifs logistiques",
  "Export": "Exportation",
  "Local": "Local",
  "Upload transactional data details": "Télécharger les détails des données transactionnelles",
  "Transactional import": "Importation transactionnelle",
  "Select quality name": "Sélectionner le nom de la qualité",
  "Volume unit, loading type & date of loading": 'Unité de volume, type de chargement et date de chargement',
  "Volume unit, loading type & date of delivery": 'Unité de volume, type de chargement et date de livraison',
};